export default () => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
  },
  body: {
    flex: 1,
    overflowY: 'scroll',
    padding: '1rem',
  },
  fullScreenBody: {
    flex: 1,
    overflow: 'auto',
    padding: '.5rem',
  },
});
